import { IFoeState } from "../interfaces/foe-state";

export const foeInitState: IFoeState = {
    loading: false,
    response: '',
    error: '',
};
